import { Input } from 'components'

import { createTimeHandler } from './utils'
import './styles.scss'

interface Props {
  onChange: (field: string) => (value: string | number) => void
  hoursValue: string
  minutesValue: string
  hoursFieldName: string
  minutesFieldName: string
  enableTabIndex?: boolean
}

export const IntervalInputs = (props: Props) => {
  const { onChange, hoursValue, minutesValue, hoursFieldName, minutesFieldName, enableTabIndex } =
    props

  const onChangeHours = (fieldName: string) => createTimeHandler(fieldName, 100, onChange)

  const onChangeMinutes = (fieldName: string) => createTimeHandler(fieldName, 60, onChange)

  return (
    <div className="interval-inputs-wrapper">
      <label className="label">
        <span>через</span>
        <Input
          className="input"
          inputMode="numeric"
          value={hoursValue}
          onInput={onChangeHours(hoursFieldName)}
          tabIndex={enableTabIndex ? 0 : -1}
        />
        <span>ч</span>
      </label>
      <label className="label">
        <Input
          className="input"
          inputMode="numeric"
          value={minutesValue}
          onInput={onChangeMinutes(minutesFieldName)}
          tabIndex={enableTabIndex ? 0 : -1}
        />
        <span>мин</span>
      </label>
    </div>
  )
}
